<template>
  <div class="inner-content">
    <h2 style="margin-bottom: 20px;">新しいメールアドレスを入力</h2>
    <Spinner :isLoading="isLoading" />
    <div>
      <form @submit.prevent="onChangeEmail()" method="post">
          <p class="mb10" style="font-size: 14px;">新しいメールアドレスを入力してください</p>
          <input
            type="text"
            class="change-email mb10"
            v-model="changeEmail.email"
            :class="[$v.changeEmail.email.$error ? 'input-error' : '']"
          />
          <div v-if="changeEmailSubmitted && $v.changeEmail.email.$error">
            <p class="error-txt mb20" v-if="!$v.changeEmail.email.required">
              {{ $t("please_enter_your_registered_email_address") }}
            </p>
            <p
              class="error-txt mb20"
              v-if="$v.changeEmail.email.required && !$v.changeEmail.email.email"
            >
              {{ $t("the_format_of_the_email_address_is_different") }}
            </p>
          </div>
          <div class="mb10">
            <p
              class="error-txt mb10"
              v-if="changeEmailSubmitted && !$v.changeEmail.email.$error"
            >
              {{ errorSendEmail }}
            </p>
          </div>
          <button class="btn-base mb20" type="submit" style="border: #ffa300">
            <a style="font-weight: 600;"><p>送信</p></a>
          </button>
        </form>
    </div>
  </div>
</template>
  
  <script>
import { required, email } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import Spinner from "@/js/components/Spinner";

export default {
  data() {
    return {
      changeEmail: {
        email: "",
      },
      changeEmailSubmitted: false,
      isLoading: false,
    };
  },
  validations: {
    changeEmail: {
      email: { required, email },
    },
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapState({
      errorSendEmail: (state) => state.auth.errorSendEmail,
      access_token: (state) => state.auth.access_token,
    }),
  },
  mounted() {
    this.screenTracking(this.$t("those_who_have_forgotten_PW"));
  },
  methods: {
    async onChangeEmail() {
      this.changeEmailSubmitted = true;
      this.$v.changeEmail.$touch();
      if (this.$v.changeEmail.$error) return;
      else {
        this.isLoading = true
        const email = this.changeEmail.email.trim().toLowerCase();
        await this.$store.dispatch("auth/changeEmail", { email: email, access_token: this.access_token });
        if (!this.errorSendEmail) {
          this.$store.dispatch('auth/setEmailReset', email)
          this.$router.push({ path: "/confirm-change-email" }).catch((err) => {});
        }
      }
      this.isLoading = false
    },
  },
};
</script>
<style scoped>
.change-email {
  box-sizing: border-box;
  width: 400px;
  padding: 6px;
  border: 1px solid #ff9fae;
}
.error-txt {
  color: #ff0000;
  font-size: 0.8rem;
}
</style>